const assertNever = (_: never): never => {
  throw Error(`Unhandled switch case ${_ as any}`);
};

export default assertNever;
